import { getAuthAxiosBackend } from "../helpers/axios"

class AdminServices{

    get(id){
        return getAuthAxiosBackend().get('Security/User/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('Security/User', {params: data})
    }

    add(admin){
        return getAuthAxiosBackend().post('Security/User', admin)
    }

    edit(id, admin){
        return getAuthAxiosBackend().put('Security/User/'+id, admin)
    }

    delete(id){
        return getAuthAxiosBackend().delete('Security/User/'+id)// change to softdelete next time.
    }

    resetPassword(id, data){
        return getAuthAxiosBackend().patch('Security/User/' + id + '/reset-password', data)
    }
}

export default new AdminServices()